import tryPerformRowAutoMarkAsRead from '../../helpers/tryPerformRowAutoMarkAsRead';
import TableView from 'owa-mail-list-store/lib/store/schema/TableView';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import { action, select } from 'satcheljs/lib/legacy';

export interface OnSingleSelectionChangedState {
    userOptions: UserOptionsType;
}

/**
 * Called when the table has single selection, and user selects another single conversation
 * @param rowKey the rowKey to be marked as read
 * @param tableView the tableView where the single selection changed
 * @param isUserNavigation whether the navigation is triggerred by the user
 * @param state the state which contains globalReadingPanePositionReact in user options
 */
export default action('onSingleSelectionChanged')(
    select({
        userOptions: () => getUserConfiguration().UserOptions,
    })(function onSingleSelectionChanged(
        rowKey: string,
        tableView: TableView,
        isUserNavigation: boolean,
        state?: OnSingleSelectionChangedState
    ) {
        const userOptions = state.userOptions;

        // Do nothing when user changes single selection in single line view
        if (userOptions.GlobalReadingPanePositionReact == ReadingPanePosition.Off) {
            return;
        }

        if (userOptions.PreviewMarkAsRead == 'OnSelectionChange' && isUserNavigation) {
            tryPerformRowAutoMarkAsRead(rowKey, tableView);
        }
    })
);
